import { Role, RolesArea } from '../../types/roles';
import {
  REMOVE_ROLE_SUCCESS,
  RemoveRoleSuccessAction,
  SET_ROLE_AREAS, SET_ROLE_SUCCESS,
  SetRoleAreasAction, SetRoleSuccessAction
} from '../actions/action-types';

export const roleAreas = (state: RolesArea[] = [], action: SetRoleAreasAction | SetRoleSuccessAction | RemoveRoleSuccessAction): RolesArea[] => {
  switch (action.type) {
    case SET_ROLE_AREAS:
      return action.roleAreas;
    case SET_ROLE_SUCCESS: {
      const customRolesArea = state.shift();
      const roleIndex = getRoleIndex(customRolesArea, action.role.id);
      const customRoles = [...customRolesArea?.roles?.slice(0, roleIndex), action.role, ...customRolesArea.roles.slice(roleIndex + 1)] ?? [];
      return [{ title: customRolesArea?.title, roles: customRoles as Role[] }].concat(state);
    }
    case REMOVE_ROLE_SUCCESS: {
      const customRolesArea = state.shift();
      const customRoles = customRolesArea?.roles?.filter(role => role.id !== action.roleId) ?? [];
      return [{ title: customRolesArea?.title, roles: customRoles as Role[] }].concat(state);
    }
    default:
      return state;
  }
};

const getRoleIndex = (customRoleArea: RolesArea, roleId: string): number => {
  const roleIndex = customRoleArea.roles.findIndex(role => roleId === role.id);
  return roleIndex > -1 ? roleIndex : customRoleArea.roles.length;
};
